import React from "react";
import { deleteMerchantAccount } from "actions/merchantAccount";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ConfirmButton from "components/ConfirmButton";
import Analytics, { DELETE_MERCHANT_ACCOUNT } from "utils/analytics";
import { useLoginWithStripe } from "utils/state";
import { useCtxReferences } from "utils/selectors";

const DEFAULT_CTA = "Connect Stripe account";

const DEFAULT_SLIDES = [
  {
    title: DEFAULT_CTA,
    header:
      "Log in to Stripe to connect one of your existing Stripe accounts to PriceBlocs.",
    subheader:
      "This will remove your temporary Stripe account which was created during PriceBlocs onboarding."
  }
];

/**
 * Want to prevent the creation of a duplicate Stripe account so we show a condirmation modal which will delete the deferred account and allow for the connection of an existing Stripe account
 * @param {Object} params
 * @param {Object} params.actions
 * @returns
 */
const ResetStripeConnect = ({ actions, ...props }) => {
  const { resource, resourceUUID, merchantAccount } = useCtxReferences();
  const loginLink = useLoginWithStripe();

  const deleteMerchantAccount = () => {
    Analytics.track(DELETE_MERCHANT_ACCOUNT, {
      merchant_account_id: merchantAccount.id,
      service: merchantAccount.service,
      account_uid: merchantAccount.service_uid
    });

    actions.deleteMerchantAccount(
      { resource, resourceUUID, uuid: merchantAccount.uuid },
      {
        serviceUID: merchantAccount.service_uid
      },
      () => {
        window.location.href = loginLink;
      }
    );
  };

  return (
    <ConfirmButton
      {...props}
      copy={DEFAULT_CTA}
      slides={DEFAULT_SLIDES}
      onConfirm={deleteMerchantAccount}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      deleteMerchantAccount
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ResetStripeConnect);
